
import {defineComponent} from "vue";
import InputText from "@/components/UI/InputText.vue";
import {
  ProductCustomNamesOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/ProductCustomNamesOverviewRestDtoModel";
import {MultilingualFieldRestDtoModel} from "@/models/api/pharma-order-enum/MultilingualFieldRestDtoModel";
import {CatalogProductsRestService} from "@/services/rest/cpc-mgmt/CatalogProductsRestService";
import {ProductCustomNameRestDtoModel} from "@/models/api/pharma-cpc-product-mgmt/ProductCustomNameRestDtoModel";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {FormMixin} from "@/components/base/FormMixin";

export default defineComponent({
  name: "CustomNames",
  mixins: [FormMixin],
  components: {
    GenericFormWrapper,
    InputText,
  },
  emits: ["savedSuccessfully"],
  props: {
    productCode: {
      type: String,
      required: true
    },
  },
  data: () => ({
    customNames: ProductCustomNamesOverviewRestDtoModel.createWithDefaults(),
  }),
  mounted() {
    this.reloadContent();
  },
  methods: {
    async doReload() {
      this.customNames = await CatalogProductsRestService.getInstance()
        .findProductCustomNames(this.productCode, this.productCode);
      if (!this.customNames.custom_name) {
        this.customNames.custom_name = ProductCustomNameRestDtoModel.createWithDefaults();
      } else if (!this.customNames.custom_name.name) {
        this.customNames.custom_name.name = MultilingualFieldRestDtoModel.createWithDefaults();
      }
    },
    async doSubmit(): Promise<void> {
      await CatalogProductsRestService.getInstance().syncProductCustomNames(this.productCode, this.customNames.custom_name);
      this.$emit('savedSuccessfully', null);
    },
    async afterSave(): Promise<void> {
      // Do nothing
    },
  },
});
